import { GetListBase } from "../client-parent/client-parent.model";
export class ClientDetailsShow {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    status_Name: string;
    userName: string;
    dob: string;
    age: number;
    weight: number | null;
    aKA: string;
    medicaid: string;
    medicare: string;
    street: string;
    street2: string;
    apt: string;
    phone1: string;
    phone2: string;
    county: string;
    city: string;
    state: string;
    zipCode: string;
    sSN: string;
    email: string;
    isEin: string;
    requireEVV: boolean;
    internalId: string;
    pClientId: string;
    insuranceNo: string;
    billto_Name: string;
    billto_Street: string;
    billto_City: string;
    billto_State: string;
    billto_Zipcode: string;
    billto_Phone: string;
    billto_Email: string;
    mA_PMI: string;
    county_fiscalResponsibility: string;
    locationId: string;
    priorityStatusLid: string | null;
    genderLid: string;
    assessmentRatingLid: string | null;
    pCATypeLid: string | null;
    typeofWaiverLid: string | null;
    isEinLid: string | null;
    statusLid: string;
    agencyId: string;
    loginUserId: string | null;
    locationName: string;
    name: string;
    gender_Name: string;
    assessmentRatingName: string;
    pCATypeName: string;
    typeofWaiverName: string;
    priorityStatusName: string;
}
export class AgencyDetails {
    id: string;
    statusLid: string;
    agencyCode: string;
    agencyName: string;
    agencyShortName: string;
    agencyLogo: string;
    email: string;
    phone: string;
    fax: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    altStreet: string;
    altCity: string;
    altState: string;
    altZipcode: string;
}

export class SupportPlannerDetailsBO {
    id: string;
    agencyId: string;
    name: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    fax: string;
    email: string;
}
export class CaseManagerBO {
    id: string;
    name: string;
    state: string;
    street: string;
    zip: string;
    city: string;
    phone: string;
    fax: string;
    agencyId: string;
    email: string
}
export class ClientContactInfoBO {
    id: string;
    contactTypeLid: string;
    contactType_Lov: string;
    relationshipLid: string | null;
    relationship_Lov: string;
    phoneCarrierLid: string | null;
    phoneCarrier_Lov: string;
    clientId: string;
    clientName: string;
    agencyId: string;
    name: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    county: string;
    phoneNumber: string;
    alternatePhoneNumber: string;
    fax: string;
    email: string;
    clinic: string;
}

export class GoalBO {

}
export class functionpermission {
    agencycreate: boolean = true;
    agencydelete: boolean = true;
    agencyupdate: boolean = true;
}
export class BudgetImportBO {
    isabasicadvance: boolean = false;
    isDisable: boolean = false;
    edit: boolean;
    clientId: string = "00000000-0000-0000-0000-000000000000";
    // onboardingId: string="00000000-0000-0000-0000-000000000000";
    id: string = "00000000-0000-0000-0000-000000000000";
    insuranceNumber: string;
    budgetStartDate: string = "";
    budgetEndDate: string = "";
    budgetAmt: number | null;
    budgetdate: string | null;
    comments: string = "";
    budgetTypeLid: string | null;
    caseManagerContactName: string;
    caseManagerEmail: string;
    fseContactName: string;
    fseEmail: string;
    supportPlannerContactName: string;
    supportPlannerEmail: string;
    supportPlannerId: string;
    casemanagerId: string | null;

    representativeContacts: RepresentativeContactsBO[];
    additionalContactsBo: RepresentativeContactsBO[];

    doctorContactId: string | null;
    hospitalContactId: string | null;
    schoolContactId: string | null;
    budgetEvaluationOfLastYearPlansBO: BudgetEvaluationOfLastYearPlansBO[];
    wereThereanyServicesOrSupports: string;
    employeeModelLid: string;

    planStrengths: string;
    planNeeds: string;
    planLikes: string;
    planDisLikes: string;
    plan_DisabilityOrHealthCondition: string;
    plan_DiagnosisCondition: string;


    personalAssistanceSkillsOrTraining: string;
    personalAssistanceNeedTheseServices: string;
    paidParentOfminorOrSpouseAsStaff: string;
    choosingMySpousetobeMyCareProvider: boolean | null;
    scheduleJobDuties: string;

    goalstable: Goals[];
    personalAssistance: AuthBo[];
    personalAssistanceGrandTotal: number | null = 0;


    personalAssistanceGoods: AuthBo[];
    personalAssistanceGoodsGrandTotal: number | null = 0;


    scheduleBOsp: ScheduleBO[];

    treatmentTraining: AuthBo[];
    treatmentTrainingGoods: AuthBo[];
    treatmentTrainingGrandTotal: number | null = 0;;
    treatmentTrainingGoodsGrandTotal: number | null;

    treatmentTrainingSkillsOrTraining: string;
    treatmentTrainingNeedTheseServices: string;
    budgetAmountIncludeAdditionalFunds: string;
    employmentSupportsOrdayservicesCurrent: string;
    employmentSupportsOrdayservicesUpcomingyear: string;
    employmentSupportsOrdayservicesAnnualCost: number | null;
    environmentalModificationsSkillsOrTraining: string;
    environmentalodificationsNeedTheseServices: string;
    listOtherUniqueQualifications: string;

    environmentalMods: AuthBo[];
    environmentalModsGoods: AuthBo[];

    environmentalModsGrandTotal: number | null = 0;
    environmentalModsGoodsGrandTotal: number | null;

    selfDirectionBO: AuthBo[];
    selfDirectionBOGrandTotal: number | null = 0;


    budgetHealthandSafetyMonitors: BudgetHealthandSafetyMonitors[];
    budgetExpendituresMonitor: BudgetExpendituresMonitorBO[];
    personusingCdcs: boolean | null;
    licensedAgency: boolean | null;
    parentResponsibleParty: boolean | null;
    pcaAgency: boolean | null;
    supportPlanner: boolean | null;
    other_who: boolean | null;
    otherWhotext: string;
    healthandSafetyPlanDate: string | null;
    healthandSafetyIssues: string;
    whatwillDoInCaseDate: string | null;
    whoDoYouCall_Name: string;
    alternatePerson_Name: string;
    whoDoYouCall_Phone: string;
    alternatePerson_Phone: string;
    numberOfDaysOfPlanYear: string;
    budgetSign: string;
    budgetSignDate: string | null;
    budgetSign1: string;
    budgetSignDate1: string | null;
    budgetSign2: string;
    budgetSignDate2: string | null;
    budgetSign3: string;
    budgetSignDate3: string | null;
    planIncludesHabilitativeComponent: boolean | null;
    healthSafetyEmergencyPlan: boolean | null;
    thisPlanBudgetApproved: boolean | null;


    // personRecevingServices:personRecevingServicesBO=new  personRecevingServicesBO();
    // parentOrLegalRepresentativeOrManagingParty:ParentOrLegalRepresentativeOrManagingPartyBO[]=[];
    // leadAgencyOrCountyOrRepresentativeOrCareManager:ResidentDetailsBO=new ResidentDetailsBO();
    // fiscalSupportEntity:ResidentDetailsBO=new ResidentDetailsBO();
    // supportPlanner: ResidentDetailsBO=new ResidentDetailsBO();
    employeeModel: string | null;
    additionalContact: AdditionalContactBO = new AdditionalContactBO();
    evaluationOfLastYearPlan: EvaluationOfLastYearPlanBO[] = [];
    // anyServiceOrSupportNotAvailable: string;
    plan: PlanBO = new PlanBO();
    // personalAssistance: PersonalAssistanceBO=new PersonalAssistanceBO();
    // treatmentAndTraining: TreatmentAndTrainingBO=new TreatmentAndTrainingBO();
    // environmentalModificationAndProvisions: EnvironmentalModificationAndProvisionsBO=new EnvironmentalModificationAndProvisionsBO();
    // selfDirectionSupportActivities: SelfDirectionSupportActivitiesBO=new SelfDirectionSupportActivitiesBO();
}

export class ReturnBudgetBO extends BudgetImportBO {
    representativeContacts: RepresentativeContactsBO[];
    additionalContactsBo: RepresentativeContactsBO[];
    budgetEvaluationOfLastYearPlansBO: BudgetEvaluationOfLastYearPlansBO[];
    personalAssistance: AuthBo[];
    personalAssistanceGoods: AuthBo[];
    goalstable: Goals[];
    scheduleBOsp: ScheduleBO[];
    treatmentTraining: AuthBo[];
    treatmentTrainingGoods: AuthBo[];
    environmentalMods: AuthBo[];
    environmentalModsGoods: AuthBo[];
    selfDirectionBO: AuthBo[];
    budgetHealthandSafetyMonitors: BudgetHealthandSafetyMonitors[];
    budgetExpendituresMonitor: BudgetExpendituresMonitorBO[];
}

export class Budgetbase {
    id: string;
    budgetStartDate: string;
    budgetEndDate: string;
    budgetAmt: number;
    budgetdate: string | null;
    comments: string;
    caseManagerContactName: string;
    caseManagerEmail: string;
    fseContactName: string;
    fseEmail: string;
    supportPlannerContactName: string;
    supportPlannerEmail: string;
    wereThereanyServicesOrSupports: string;
    planStrengths: string;
    planNeeds: string;
    planLikes: string;
    planDisLikes: string;
    plan_DisabilityOrHealthCondition: string;
    plan_DiagnosisCondition: string;
    personalAssistanceSkillsOrTraining: string;
    personalAssistanceNeedTheseServices: string;
    paidParentOfminorOrSpouseAsStaff: string;
    choosingMySpousetobeMyCareProvider: boolean | null;
    scheduleJobDuties: string;
    treatmentTrainingSkillsOrTraining: string;
    treatmentTrainingNeedTheseServices: string;
    budgetAmountIncludeAdditionalFunds: string;
    employmentSupportsOrdayservicesCurrent: string;
    employmentSupportsOrdayservicesUpcomingyear: string;
    employmentSupportsOrdayservicesAnnualCost: number | null;
    environmentalModificationsSkillsOrTraining: string;
    environmentalodificationsNeedTheseServices: string;
    listOtherUniqueQualifications: string;
    personusingCdcs: boolean | null;
    licensedAgency: boolean | null;
    parentResponsibleParty: boolean | null;
    pcaAgency: boolean | null;
    supportPlanner: boolean | null;
    other_who: boolean | null;
    otherWhotext: string;
    healthandSafetyPlanDate: string | null;
    healthandSafetyIssues: string;
    whatwillDoInCaseDate: string | null;
    whoDoYouCall_Name: string;
    alternatePerson_Name: string;
    whoDoYouCall_Phone: string;
    alternatePerson_Phone: string;
    numberOfDaysOfPlanYear: string;
    budgetSign: string;
    budgetSignDate: string | null;
    budgetSign1: string;
    budgetSignDate1: string | null;
    budgetSign2: string;
    budgetSignDate2: string | null;
    budgetSign3: string;
    budgetSignDate3: string | null;
    planIncludesHabilitativeComponent: boolean | null;
    healthSafetyEmergencyPlan: boolean | null;
    thisPlanBudgetApproved: boolean | null;
    doctorContactId: string | null;
    hospitalContactId: string | null;
    schoolContactId: string | null;
    supportPlannerId: string | null;
    casemanagerId: string | null;
    clientId: string;
    employeeModelLid: string | null;
    budgetTypeLid: string | null;
    agencyId: string;
}

export class personRecevingServicesBO {
    name: string = "";
    dob: string | null;
    pmi: string = "";
    medicareOrInsuranceNumber: string;
    streetAddress: string = "";
    city: string = "";
    state: string = "";
    zipcode: string = "";
    email: string = "";
    phoneNumber: string = "";
    countyOfResidence: string = "";
    countyOfFinancialResidence: string = "";
    waiverType: string = "";
    waiverTypeLid: string = "";
}

export class CommonAddressBO {
    streetAddress: string = "";
    city: string = "";
    state: string = "";
    zipcode: string = "";
    email: string = "";
    phoneNumber: string = "";
    fax: string = "";
}

export class ResidentDetailsBO extends CommonAddressBO {
    name: string = "";
    contactName: string = "";
}



export class ParentOrLegalRepresentativeOrManagingPartyBO {

    name: string = "";
    streetAddress: string = "";
    city: string = "";
    state: string = "";
    zipcode: string = "";
    email: string = "";
    phoneNumber: string = "";
    cellPhoneNumber: string = "";
    name1: string = "";
    streetAddress1: string = "";
    city1: string = "";
    state1: string = "";
    zipcode1: string = "";
    email1: string = "";
    phoneNumber1: string = "";
    cellPhoneNumber1: string = "";
    isadd: boolean = false

}

export class DoctorAdressBO extends CommonAddressBO {
    doctorName: string = "";
    clinic: string = "";
}

export class HospitalBO extends CommonAddressBO {
    hospitalName: string = "";
}

export class SchoolBo extends CommonAddressBO {
    schoolName: string = "";
}

export class AdditionalAddress extends CommonAddressBO {
    name: string = "";
    isadd1: boolean = false;
}

export class AdditionalContactBO {
    doctorAdress: DoctorAdressBO = new DoctorAdressBO();
    hospitalAddress: HospitalBO = new HospitalBO();
    schoolAdress: SchoolBo = new SchoolBo();
    additionalAddress: AdditionalAddress[] = []
}

export class EvaluationOfLastYearPlanBO {
    goalInNextYear: string | null;
    greatIndipendence: boolean;
    maintainHealthAndSafty: boolean;
    moreCommunityActivity: boolean;
    skillDevelopmentOrskillMaitance: boolean;
    personalDevelopment: boolean;
    maintainLivingInTheBestPlaceForMe: boolean;
    goalinput: string;
    isadd8: boolean = false;
}

export class PlanBO {
    strengths: string = "";
    needs: string = "";
    likes: string = "";
    dislikes: string = "";
    lastYourDignosisOrConditions: string = "";
    discribeYourCondition: string = "";
}

export class ServiceAssistanceBO {
    groupPayorServiceId: string | null;
    groupPayorId: string | null;
    serviceDescription: string;
    rate: number | null;
    hours: number | null;
    weeks: string | null;
    totalhours: number;
    doesPTOApply: boolean;
    doPayrollTaxApply: boolean;
    billingvalue: number;
    unitperday: string;
    total: number | null;
    addbool1: boolean = false;
    addbool2: boolean = false;
    addbool3: boolean = false;
    addbool4: boolean = false;

}

export class PersonalAssistanceBO {
    serviceAssistances: ServiceAssistanceBO[] = [];
    grandtotal: number | null;
    goal: goalBO[] = [];
    iwouldLikeTheAgency: string = "";
    iNeedTheServiceBecause: string = "";
    doYouPlanToUsePaidParent: string | null;
    iamChoosingMyspouseToBeMyCaare: boolean | null;
    jobDuties: string = "";
    schduleWeeks: SchduleWeekBo[] = [];
}
export class goalBO {

    goal: string | null;
    goalhead: string | null;
    isadd2: boolean = false;
    isadd3: boolean = false;

    isadd4: boolean = false;

}
export class SchduleWeekBo {
    monday: string = "";
    tuesday: string = "";
    wednesday: string = "";
    thursday: string = "";
    friday: string = "";
    saturday: string = "";
    sunday: string = "";
    isadd7: boolean = false;
}




export class TreatmentAndTrainingBO {
    serviceAssistance: ServiceAssistanceBO[] = [];
    grandtotal: number | null;
    schduleWeeks: SchduleWeekBo[];
    goal: goalBO[] = [];
    iwouldLikeTheAgency: string = "";
    iNeedTheServiceBecause: string = "";
    doesYourBudgetAmount: string | null;
    discribeTheSpecificemployement: string = "";
    whatAreYourPlansforEmployement: string = "";
    anualCostOfEmployement: string = "";
}

export class EnvironmentalModificationAndProvisionsBO {
    serviceAssistance: ServiceAssistanceBO[] = [];
    grandtotal: number | null;
    goal: goalBO[] = [];
    iwouldLikeTheAgency: string = "";
    iNeedTheServiceBecause: string = "";
}

export class SelfDirectionSupportActivitiesBO {
    serviceAssistance: ServiceAssistanceBO[] = [];
    grandtotal: number | null;
    payrollTaxes: string = "";
    payrollWages: string = "";
    paidTimeOff: string = "";
    pTOWages: string = "";
    uniqueQulification: string = "";
    annualBudgetBO: AnnualBudgetBO = new AnnualBudgetBO();
}

export class AnnualBudgetBO {
    annualBudget: number | null;
    budgetCoverPlanStart: string | null;
    budgetCoverPlanEnd: string | null;
    personalCareAttendance: PersonalCareAttendanceBO = new PersonalCareAttendanceBO();
    nursingServices: NursingServicesBO = new NursingServicesBO();
    monitor: MonitorBO = new MonitorBO();
}

export class PersonalCareAttendanceBO {
    serviceAssistance: ServiceAssistanceBO[] = [];
    grandtotal: number | null;
    unitsForFirst6Months: number | null;
    unitsForFirst6Months1: number | null;
    unitsOfPCASupervision: number | null;
}

export class NursingServicesBO {
    serviceAssistance: ServiceAssistanceBO[] = [];
    grandtotal: number | null;
    totalPersonAssistance: number = 0;
    totalTreatmentandTraining: number = 0;
    totalEnvironmentModification: number = 0;
    totalSelfDirectionSupportActivities: number = 0;
    totalMAHomeCareService: number | null;
    grandTotal: number = 0;
    usedBudgetAmount: number = 0;
}

export class MonitorBO {
    whowillMonitors: WhowillMonitorBO[] = [];
    whowillMonitors1: WhowillMonitorBO[] = [];
    whowillresponce: WhowillresponceBO = new WhowillresponceBO();
    healthandSafetyPlanBO: healthandSafetyPlan = new healthandSafetyPlan();
    fiscalSupportEntityStaff: string;
}

export class WhowillMonitorBO {
    name: string = "";
    shceduleLid: string | null;
    speficyOthers: string = "";
    isadd5: boolean = false;
    isadd6: boolean = false;
}

export class WhowillresponceBO {
    personUsingCDCS: boolean;
    licenseAgency: boolean;
    parent: boolean;
    supportPlaner: boolean;
    otherWeDo: boolean;
    comments: string = "";

}

export class healthandSafetyPlan {
    date: string | null;
    howWillmeetYourHeathandsafetyNeeds: string = "";
    receipientSign: string = "";
    receipientSignDate: string | null;
    parent_Legal_Representative_Managing_Party_Sign: string = "";
    parent_Legal_Representative_Managing_Party_SignDate: string | null;
    this_plan_includes_a_habilitative_component: boolean;
    health_Safety_Emergency_Plan_have_been_reviewed: boolean;
    this_plan_and_budget_approved: boolean;
    lead_Agency_Representative_Care_Manager_Sign: string = "";
    lead_Agency_Representative_Care_Manager_SignDate: string | null;
    whatWill_IDoInCaseDate: string | null;
    whatWill_IDoInCaseName: string = "";
    whatWill_IDoInCasePhone: string = "";
    whatWill_IDoInCaseAltName: string = "";
    whatWill_IDoInCaseAltPhone: string = "";
}



// -------------------New BO----------------------------

export class BudgetBo {
    id: string;
    budgetStartDate: string;
    budgetEndDate: string;
    budgetAmt: number;
    budgetdate: string | null;
    comments: string;
    caseManagerContactName: string;
    caseManagerEmail: string;
    fseContactName: string;
    fseEmail: string;
    supportPlannerContactName: string;
    supportPlannerEmail: string;
    wereThereanyServicesOrSupports: string;
    planStrengths: string;
    planNeeds: string;
    planLikes: string;
    planDisLikes: string;
    plan_DisabilityOrHealthCondition: string;
    plan_DiagnosisCondition: string;
    personalAssistanceSkillsOrTraining: string;
    personalAssistanceNeedTheseServices: string;
    paidParentOfminorOrSpouseAsStaff: string;
    choosingMySpousetobeMyCareProvider: boolean;
    scheduleJobDuties: string;
    treatmentTrainingSkillsOrTraining: string;
    treatmentTrainingNeedTheseServices: string;
    budgetAmountIncludeAdditionalFunds: string;
    employmentSupportsOrdayservicesCurrent: string;
    employmentSupportsOrdayservicesUpcomingyear: string;
    employmentSupportsOrdayservicesAnnualCost: number | null;
    environmentalModificationsSkillsOrTraining: string;
    environmentalodificationsNeedTheseServices: string;
    listOtherUniqueQualifications: string;
    personusingCdcs: boolean | null;
    licensedAgency: boolean | null;
    parentResponsibleParty: boolean | null;
    pcaAgency: boolean | null;
    supportPlanner: boolean | null;
    other_who: boolean | null;
    otherWhotext: string;
    healthandSafetyPlanDate: string | null;
    healthandSafetyIssues: string;
    whatwillDoInCaseDate: string | null;
    whoDoYouCall_Name: string;
    alternatePerson_Name: string;
    whoDoYouCall_Phone: string;
    alternatePerson_Phone: string;
    numberOfDaysOfPlanYear: string;
    budgetSign: string;
    budgetSignDate: string | null;
    budgetSign1: string;
    budgetSignDate1: string | null;
    budgetSign2: string;
    budgetSignDate2: string | null;
    budgetSign3: string;
    budgetSignDate3: string | null;
    planIncludesHabilitativeComponent: boolean | null;
    healthSafetyEmergencyPlan: boolean | null;
    thisPlanBudgetApproved: boolean | null;
    doctorContactId: string | null;
    hospitalContactId: string | null;
    schoolContactId: string | null;
    supportPlannerId: string | null;
    casemanagerId: string | null;
    clientId: string;
    employeeModelLid: string | null;
    budgetTypeLid: string | null;
    agencyId: string;
    representativeContacts: RepresentativeContacts[];
    additionalContactsBo: RepresentativeContacts[];
    budgetEvaluationOfLastYearPlansBO: BudgetEvaluationOfLastYearPlansBO[];
    personalAssistance: AuthBo[];
    personalAssistanceGoods: AuthBo[];
    goalstable: Goals[];
    scheduleBOsp: ScheduleBO[];
    treatmentTraining: AuthBo[];
    treatmentTrainingGoods: AuthBo[];
    environmentalMods: AuthBo[];
    environmentalModsGoods: AuthBo[];
    selfDirectionBO: AuthBo[];
    budgetHealthandSafetyMonitors: BudgetHealthandSafetyMonitors[];
    budgetExpendituresMonitor: BudgetExpendituresMonitorBO[];
}



export class RepresentativeContacts {
    id: string;
    contactId: string;


}

export class BudgetEvaluationOfLastYearPlansBO {
    id: string;
    evaluationPlanGoal: string;
    greatIndipendence: boolean;
    maintainHealthAndSafty: boolean;
    moreCommunityActivity: boolean;
    skillDevelopmentOrskillMaitance: boolean;
    personalDevelopment: boolean;
    maintainLivingInTheBestPlaceForMe: boolean;
    plantoWorkonNextyearPlan: string;
}

export class AuthBo {
    id: string;
    startDate: string;
    endDate: string;
    authTypelid: string;
    groupPayorId: string;
    serviceId: string;
    serviceDescription: string;
    totalhours: number;
    totalNoWeeksOrMonths: number;
    rate: number;
    usedAmt: number | null;
    totalAmt: number | null;
    doesPtoApply: boolean;
    payrollTaxApply: boolean;
    clientId: string;

    serviceAgreementNumber: string;
    icD10Code: string;
    isTaxable: boolean;
    companyId: string;
    authNote: string;
    authNotes: string;
    companyName: string;
    payorName: string;
    serviceName: string;
}

export class Goals {
    id: string;
    goal: string;
    goalType: string;
}

export class ScheduleBO {
    id: string;
    monday: string;
    tuesday: string;
    wednesday: string;
    thursday: string;
    friday: string;
    saturday: string;
    sunday: string;
}

export class BudgetHealthandSafetyMonitors {
    id: string;
    healthandSafety: string;
    howoffen: string;
    howoffenOther_text: string;
}

export class BudgetExpendituresMonitorBO {
    id: string;
    healthandSafety: string;
    fiscalSupportEntityStaff: string;
    howoffen: string;
    howoffenOther_text: string;
    fiscalSupportEntityStaff_Howoffen: string;
    fiscalSupportEntityStaff_HowoffenOther_text: string;
}

export class BudgetReturnBO {
    id: string;
    budgetStartDate: string;
    budgetEndDate: string;
    budgetAmt: number;
    clientId: string;
    agencyId: string;
    clientName: string;
}
export class FilterBo extends GetListBase {
    clientId: string;
    agencyId: string;

}
export class RepresentativeContactsBO extends RepresentativeContacts {
    name: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    county: string;
    phoneNumber: string;
    alternatePhoneNumber: string;
    fax: string;
    email: string;
    clinic: string;
    contactTypeLid: string;
    relationshipLid: string | null;
    phoneCarrierLid: string | null;
    clientId: string;
    agencyId: string;
}

// export class ReturnBudgetBO extends Budgetbase {
//     representativeContacts: RepresentativeContactsBO[];
//     additionalContactsBo: RepresentativeContactsBO[];
//     budgetEvaluationOfLastYearPlansBO: BudgetEvaluationOfLastYearPlansBO[];
//     personalAssistance: AuthBo[];
//     personalAssistanceGoods: AuthBo[];
//     goalstable: Goals[];
//     scheduleBOsp: ScheduleBO[];
//     treatmentTraining: AuthBo[];
//     treatmentTrainingGoods: AuthBo[];
//     environmentalMods: AuthBo[];
//     environmentalModsGoods: AuthBo[];
//     selfDirectionBO: AuthBo[];
//     budgetHealthandSafetyMonitors: BudgetHealthandSafetyMonitors[];
//     budgetExpendituresMonitor: BudgetExpendituresMonitorBO[];
// }

